import {EventEmitter} from 'events';
import Dispatcher from 'common/events/dispatcher';

// Constants
const CHANGE_EVENT = 'change';

// Data structures that this store manipulates
let _data = {};
let _meta = {};
let _details = {};

function _updateTenantData(data, meta) {
  _data = data;
  _meta = meta;
}

function _updateTenantDetails(details) {
  _details = details;
}

const TenantStore = {
  ...EventEmitter.prototype,
  emitChange() {
    this.emit(CHANGE_EVENT);
  },

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  getTenantData() {
    return _data;
  },

  getTenantMeta() {
    return _meta;
  },

  getTenantDetails() {
    return _details;
  },
};

TenantStore.dispatchToken = Dispatcher.register((payload) => {
  const action = payload.action;
  if (action === 'UPDATE_TENANT_DATA') {
    _updateTenantData(payload.data, payload.meta);
    TenantStore.emitChange();
  }

  if (action === 'UPDATE_TENANT_DETAILS') {
    _updateTenantDetails(payload.tenant);
    TenantStore.emitChange();
  }
});

export default TenantStore;
